import axios, {
  AxiosRequestConfig,
  AxiosInstance,
  AxiosResponse,
  AxiosError
} from 'axios'

const defaultRequestInterceptors = (cfg: AxiosRequestConfig) => cfg
const defaultResponseInterceptors = (response: AxiosResponse) => response
const defaultErrorInterceptors = (err: AxiosError) => Promise.reject(err)

interface IXhrOptions {
  requestInterceptors?: (cfg: AxiosRequestConfig) => AxiosRequestConfig | Promise<AxiosRequestConfig>
  responseInterceptors?: (response: AxiosResponse) => AxiosResponse
  errorInterceptors?: (err: AxiosError) => Promise<any>
}

class Xhr {
  private axios: AxiosInstance
  private defaultConfig: AxiosRequestConfig

  constructor(config: AxiosRequestConfig, options: IXhrOptions = {}) {
    this.defaultConfig = {
      baseURL: config.baseURL,
      method: 'GET', // default method
      headers: {
        Accept: 'application/json;charset=UTF-8',
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }
    const axiosInstance = axios.create(config)

    const requestInterceptors = options.requestInterceptors || defaultRequestInterceptors
    const responseInterceptors = options.responseInterceptors || defaultResponseInterceptors
    const errorInterceptors = options.errorInterceptors || defaultErrorInterceptors

    axiosInstance.interceptors.request.use(
      requestInterceptors,
      errorInterceptors
    )
    axiosInstance.interceptors.response.use(
      responseInterceptors,
      (err: AxiosError) => {
        if (err.response) {
          responseInterceptors(err.response)
        } else if (err.request) {
          console.error(err.request)
        } else {
          console.error(err.message)
        }
      }
    )

    this.axios = axiosInstance
  }

  public send(options: AxiosRequestConfig) {
    const requestOptions = { ...this.defaultConfig,timeout: 1500000, ...options }
    return this.axios(requestOptions).then(res => {
      if (!!res) {
        return res.data
      }
      return {
        ok: false,
        data: null,
        msg: 'something went wrong',
      }
    })
  }
}

export default Xhr
